import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { Services } from './Services.js';
import { servicesProviderCoverageVendorDataSchema } from './ServicesProviderCoverageVendorData.js';
import { PayableServicesProvider } from './ServicesProviderPayable.js';

class ServicesProviderCoverageVendor extends PayableServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
    }
    validateData(data) {
        const result = servicesProviderCoverageVendorDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderCoverageVendor.validation', `ServicesProviderCoverageVendor data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.COVERAGE_VENDOR,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.COVERAGE_VENDOR, ServicesProviderCoverageVendor);

export { ServicesProviderCoverageVendor };
//# sourceMappingURL=ServicesProviderCoverageVendor.js.map
